<template>
    <div>
        <kgr-empty
            v-if="departments.length === 0"
            :value="$t('Es wurden keine Ergebnisse gefunden.')"
        />

        <div v-else>
            <kgr-departments-table
                v-if="view === 'list'"
                :departments="departments"
                :filter="filter"
            />

            <kgr-departments-grid
                v-if="view === 'grid'"
                :departments="departments"
                :include-children="includeChildren"
                :filter="filter"
            />
        </div>
    </div>
</template>

<script>
import EmptyData from '../common/EmptyData';
import KgrDepartmentsGrid from './DepartmentsGrid';
import KgrDepartmentsTable from './DepartmentsTable';

export default {
    name: 'KgrDepartmentsList',
    components: {
        KgrDepartmentsGrid,
        KgrDepartmentsTable,
        'kgr-empty': EmptyData,
    },
    props: {
        departments: {
            type: Array,
            required: true,
        },
        filter: {
            type: String,
            required: false,
        },
        view: {
            type: String,
            required: true,
        },
        includeChildren: {
            type: Boolean,
            required: true,
        },
    },
}
</script>
